module.exports = __webpack_public_path__ + "static/img/logo_bg2x.e2865b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_bg2x.png
// module id = xL4U
// module chunks = 0